"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepEquals = void 0;
var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
  var e_1, _a;

  try {
    for (var _b = __values(iter.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
      key = _c.value;
      if (deepEquals(key, tar)) return key;
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
}

function deepEquals(foo, bar) {
  var e_2, _a, e_3, _b;

  var ctor, len, tmp;
  if (foo === bar) return true;

  if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
    if (ctor === Date) return foo.getTime() === bar.getTime();
    if (ctor === RegExp) return foo.toString() === bar.toString();

    if (ctor === Array) {
      if ((len = foo.length) === bar.length) {
        while (len-- && deepEquals(foo[len], bar[len])) {
          ;
        }
      }

      return len === -1;
    }

    if (ctor === Set) {
      if (foo.size !== bar.size) {
        return false;
      }

      try {
        for (var foo_1 = __values(foo), foo_1_1 = foo_1.next(); !foo_1_1.done; foo_1_1 = foo_1.next()) {
          len = foo_1_1.value;
          tmp = len;

          if (tmp && typeof tmp === 'object') {
            tmp = find(bar, tmp);
            if (!tmp) return false;
          }

          if (!bar.has(tmp)) return false;
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (foo_1_1 && !foo_1_1.done && (_a = foo_1.return)) _a.call(foo_1);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      return true;
    }

    if (ctor === Map) {
      if (foo.size !== bar.size) {
        return false;
      }

      try {
        for (var foo_2 = __values(foo), foo_2_1 = foo_2.next(); !foo_2_1.done; foo_2_1 = foo_2.next()) {
          len = foo_2_1.value;
          tmp = len[0];

          if (tmp && typeof tmp === 'object') {
            tmp = find(bar, tmp);
            if (!tmp) return false;
          }

          if (!deepEquals(len[1], bar.get(tmp))) {
            return false;
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (foo_2_1 && !foo_2_1.done && (_b = foo_2.return)) _b.call(foo_2);
        } finally {
          if (e_3) throw e_3.error;
        }
      }

      return true;
    }

    if (ctor === ArrayBuffer) {
      foo = new Uint8Array(foo);
      bar = new Uint8Array(bar);
    } else if (ctor === DataView) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo.getInt8(len) === bar.getInt8(len)) {
          ;
        }
      }

      return len === -1;
    }

    if (ArrayBuffer.isView(foo)) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo[len] === bar[len]) {
          ;
        }
      }

      return len === -1;
    }

    if (!ctor || typeof foo === 'object') {
      len = 0;

      for (ctor in foo) {
        if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
        if (!(ctor in bar) || !deepEquals(foo[ctor], bar[ctor])) return false;
      }

      return Object.keys(bar).length === len;
    }
  }

  return foo !== foo && bar !== bar;
}

exports.deepEquals = deepEquals;